import { ApiError } from '@/lib/api';

/**
 * Texto para os codes de erro de centros de custo (a API decide; a tela so traduz). O code sempre vai junto, como nas demais telas.
 * Codes sem texto proprio mostram a mensagem da API.
 */
export const MENSAGENS_CENTRO: Readonly<Record<string, string>> = {
  IDENTIFICADOR_DUPLICADO: 'Já existe um centro irmão com este identificador.',
  CENTRO_PAI_NAO_ENCONTRADO: 'O centro pai não existe mais nesta empresa. Atualize a tela.',
  PAI_INATIVO: 'O centro pai está inativo: reative o pai antes.',
  PAI_NAO_E_SINTETICO: 'O destino é analítico. Só centro sintético tem filhos.',
  MOVER_PARA_DESCENDENTE: 'Não dá para mover um centro para dentro dele mesmo ou de um descendente.',
  MOVER_PARA_SI_MESMO: 'Um centro não pode ser pai de si mesmo.',
  CENTRO_COM_USO: 'Este centro já tem CPM, etapa de ficha, lote ou origem importada: não pode virar sintético.',
  ANALITICO_NAO_TEM_FILHOS: 'Este sintético tem filhos: não pode virar analítico. Mova ou exclua os filhos antes.',
  CENTRO_SINTETICO: 'Centro sintético só agrupa: CPM e etapa de ficha ficam nos analíticos.',
  SINTETICO_NAO_TEM_MINUTOS: 'Centro sintético não tem minutos disponíveis.',
  CENTRO_INATIVO: 'Este centro está inativo: reative antes de lançar CPM.',
  CODIGO_DUPLICADO: 'Já existe um centro com este código.',
  TIPO_TRABALHO_OBRIGATORIO: 'Informe o tipo de centro de trabalho',
};

/** Mensagem legivel de um erro da API de centros: texto da tela (ou a mensagem da API) + `(CODE)`. */
export function mensagemCentro(e: unknown): string {
  if (e instanceof ApiError) {
    const texto = (e.code ? MENSAGENS_CENTRO[e.code] : undefined) ?? e.message;
    return e.code ? `${texto} (${e.code})` : texto;
  }
  return 'falha de comunicação com a API';
}

/** Motivos que impedem a exclusao definitiva (codes do POST :id/excluir), em texto. */
export const MOTIVO_EXCLUSAO_TEXTO: Readonly<Record<'FILHOS' | 'CPM' | 'ETAPAS_FICHA' | 'LOTES' | 'IMPORTACAO', string>> = {
  FILHOS: 'tem centros filhos',
  CPM: 'tem CPM lançado',
  ETAPAS_FICHA: 'é etapa de ficha técnica',
  LOTES: 'está em lote de atualização de custo',
  IMPORTACAO: 'veio da importação do XARP',
};

/** O que o centro usa, a partir de /uso (so contagens; nada e calculado). */
export function motivosDoUso(uso: { filhos: number; cpm: number; etapasFicha: number; lotes: number; importacao: number }): string[] {
  const m: string[] = [];
  if (uso.filhos > 0) m.push(`${uso.filhos} ${uso.filhos === 1 ? 'centro filho' : 'centros filhos'}`);
  if (uso.cpm > 0) m.push(`${uso.cpm} ${uso.cpm === 1 ? 'lançamento de CPM' : 'lançamentos de CPM'}`);
  if (uso.etapasFicha > 0) m.push(`${uso.etapasFicha} ${uso.etapasFicha === 1 ? 'etapa de ficha técnica' : 'etapas de ficha técnica'}`);
  if (uso.lotes > 0) m.push(`${uso.lotes} ${uso.lotes === 1 ? 'lote de atualização de custo' : 'lotes de atualização de custo'}`);
  if (uso.importacao > 0) m.push('origem importada do XARP');
  return m;
}
